import React from 'react'

export default function CapacityViolation({ className }) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Back-left person */}
            <circle cx="7" cy="11" r="2.1" fill="#0891B2" />
            <rect x="4.4" y="14.5" width="5.2" height="8" rx="2.6" fill="#0891B2" />

            {/* Back-right person */}
            <circle cx="21" cy="12" r="2.1" fill="#0891B2" />
            <rect x="18.4" y="15.5" width="5.2" height="8" rx="2.6" fill="#0891B2" />

            {/* Front-center person (drawn on top) */}
            <circle cx="14" cy="10" r="2.7" fill="#0E7490" />
            <rect x="9.9" y="14" width="8.2" height="9.5" rx="4.1" fill="#0E7490" />

            {/* Capacity-exceeded warning badge */}
            <path d="M25 1L30 8H20L25 1Z" fill="#DC2626" />
            <rect x="24.4" y="3.2" width="1.2" height="2.8" fill="#FFFFFF" />
            <circle cx="25" cy="6.8" r="0.75" fill="#FFFFFF" />
        </svg>
    )
}
